import ContractualAttendanceStrategy from './ContractualAttendanceStrategy';
import DoctorAttendanceStrategy from './DoctorAttendanceStrategy';
import PoojariAttendanceStrategy from './PoojariAttendanceStrategy';

class AttendanceStrategyFactory {
     static getStrategy(employeeType) {
          console.log('🏭 Factory: Getting strategy for type:', employeeType);

          // Normalize employee type
          const normalizedType = employeeType?.toUpperCase().trim();

          switch (normalizedType) {
               case 'CONTRACTUAL_EMPLOYEE':
                    console.log('✅ Using ContractualAttendanceStrategy');
                    return new ContractualAttendanceStrategy();

               case 'DOCTOR':
                    console.log('✅ Using DoctorAttendanceStrategy');
                    return new DoctorAttendanceStrategy();

               case 'POOJARI':
                    console.log('✅ Using PoojariAttendanceStrategy');
                    return new PoojariAttendanceStrategy();

               default:
                    console.warn(`⚠️ Unknown employee type: ${employeeType}, defaulting to ContractualAttendanceStrategy`);
                    return new ContractualAttendanceStrategy();
          }
     }
}

export default AttendanceStrategyFactory;